<template>
    <div class="rcclPopover" v-if="isShow">
        <div class="yellowTip-pc">
            <div class="yellowTip-title">解绑提示</div>
            <div class="yellowTip-txt">确定要解绑此微信号？</div>
            <div class="yellowTip-btn js-popupClose" @click="cancelClick">{{buttons[0]}}</div>
            <div class="yellowTip-btn js-popupOK" @click="confirmClick">{{buttons[1]}}</div>
            <div class="button--closed" @click="cancelClick">
                <img src="../../assets/closed.png">
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'UnBindConfirm',
        data () {
            return  {
                buttons: ['取消', '确定'],
                isShow: false
            }
        },
        methods: {
            show () {
                this.isShow = true
            },
            confirmClick () {
                this.isShow = false
                this.$emit('on-confirm')
            },
            cancelClick() {
                this.isShow = false
                this.$emit('on-cancel')
            },
        }
    }
</script>

<style lang="less" scoped>
    .rcclPopover{
        position: fixed;
        left: 0;
        top: 0;
        z-index: 10500;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.8);
        .yellowTip-pc{
            position: absolute;
            left: 50%;
            top: 50%;
            width: 400px;
            background-color: #fff;
            border-radius: 6px;
            cursor: pointer;
            -webkit-transform: translate(-50%, -50%);
            -moz-transform: translate(-50%, -50%);
            -o-transform: translate(-50%, -50%);
            -ms-transform: translate(-50%, -50%);
            transform: translate(-50%, -50%);
            .yellowTip-title{
                min-height: 56px;
                padding: 15px;
                border-bottom: 1px solid #e5e5e5;
                font-size: 18px;
            }
            .yellowTip-txt{
                padding: 15px 15px 66px;
            }
            .yellowTip-btn{
                position: absolute;
                left: 50%;
                bottom: 15px;
                padding: 6px 18px;
                background: #fcc400;
                font-size: 16px;
                line-height: 26px;
                color: #031257;
                border-radius: 25px;
                -webkit-transform: translateX(-50%);
                -moz-transform: translateX(-50%);
                -o-transform: translateX(-50%);
                -ms-transform: translateX(-50%);
                transform: translateX(-50%);
                &.js-popupClose{
                    margin-left: -42px;
                }
                &.js-popupOK{
                    margin-left: 42px;
                }
            }
            .button--closed{
                position: absolute;
                top: -15px;
                right: -15px;
                width: 39px;
                cursor: pointer;
            }
        }
    }
</style>
